import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import R from 'ramda';
import Picture from '@cotyorg/ccx-atoms/Picture';
import StandardLayout from '../../templates/StandardLayout';
import { Carousel } from './Sections/Carousel/Carousel';
import { Facts } from './Sections/Facts/Facts';
import { HeaderSection } from './Sections/Header/Header';
import { HeroGirls } from './Sections/HeroGirls/HeroGirls';
import { Science } from './Sections/Science/Science';
import { MainVideo } from './Sections/MainVideo/MainVideo';
import { Video } from './Sections/Video/Video';

const MatchFinderPage = ({
  sectionHeadings,
  videos,
  hero,
  description,
  descriptionCarousel,
  image,
}) => (
  <StandardLayout>
    <div className="match-finder-page">
      <HeaderSection sectionHeadings={sectionHeadings} />

      {R.prop('imageSrc', image) && (
        <div className="match-finder-picture">
          <Picture
            alt={R.prop('alt', image)}
            src={R.prop('imageSrc', image)}
            srcset={R.prop('imageSrcSet', image)}
          />
        </div>
      )}

      <Facts sectionHeadings={sectionHeadings} section="facts" />

      {R.path(['girlsHero', 'heading'], hero) && <HeroGirls hero={hero} />}

      <Science sectionHeadings={sectionHeadings} />

      <Facts sectionHeadings={sectionHeadings} section="facts2" />

      {R.path(['video', 'title'], videos) && <Video videos={videos} />}

      {R.path(['carousel', 'heading'], sectionHeadings) && (
        <Carousel
          sectionHeadings={sectionHeadings}
          description={descriptionCarousel}
        />
      )}

      {description && <p className="match-finder-description">{description}</p>}
    </div>
  </StandardLayout>
);

MatchFinderPage.propTypes = {
  sectionHeadings: PropTypes.instanceOf(PropTypes.object),
  videos: PropTypes.instanceOf(PropTypes.object),
  hero: PropTypes.instanceOf(PropTypes.object),
  description: PropTypes.string,
  descriptionCarousel: PropTypes.string,
  image: PropTypes.instanceOf(PropTypes.object),
};

export default connect(({ content }) => ({
  sectionHeadings: R.prop('sectionHeadings', content),
  videos: R.prop('videos', content),
  hero: R.prop('hero', content),
  description: R.prop('description')(content),
  descriptionCarousel: R.prop('descriptionCarousel')(content),
  image: R.prop('image')(content),
}))(MatchFinderPage);
